import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";

const Residential = lazy(() => import("@/pages/Residential"));
const Commercial = lazy(() => import("@/pages/Commercial"));
const Franchise = lazy(() => import("@/pages/Franchise"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));

import { Switch, Route } from "wouter";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ScrollToTop />
            <div className="flex flex-col min-h-screen">
                <Navbar />
                <main className="flex-grow">
                    <Suspense fallback={<div className="min-h-screen" />}>
                        <Switch>
                            <Route path="/" component={Home} />
                            <Route path="/residential" component={Residential} />
                            <Route path="/commercial" component={Commercial} />
                            <Route path="/franchise" component={Franchise} />

                            <Route path="/privacy-policy" component={PrivacyPolicy} />
                            <Route>
                                <div className="container mx-auto py-20 text-center">
                                    <h1 className="text-4xl font-bold mb-4">404</h1>
                                    <p>Page not found</p>
                                </div>
                            </Route>
                        </Switch>
                    </Suspense>
                </main>
                <Footer />
            </div>
        </QueryClientProvider>
    );
}

export default App;

